var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{staticClass:"previewAgmPopup",class:_vm.deviceInfo.mobile ? 'mobile-previewAgmPopup' : '',attrs:{"closeable":true,"get-container":"body"},on:{"close":_vm.onClose},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('iframe',{attrs:{"src":`${_vm.PROJECT_PATH}/agm.html?agmId=${_vm.agmId}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }